import { useState } from "react";
import localize from "../../../common/localize";
import ModalBackground from "../../../components/common/ModalBackground";
import { Alert, Box, Checkbox, FormControlLabel } from "@mui/material";
import Combobox from "../../../components/common/Combobox";
import { PopperFullWidth } from "../../../common/appStyles";

export default function ClientBranchSelector({
  show,
  setShow,
  eventModel,
  setEventModel,
  client,
  branches,
}) {
  const [selectedBranch, setSelectedBranch] = useState(undefined);
  const [useMainAddress, setUseMainAddress] = useState(false);

  const cancel = () => {
    setSelectedBranch(undefined);
    setShow(false);
  };

  const submit = () => {
    if (!useMainAddress) {
      setEventModel({
        ...eventModel,
        Address: selectedBranch.Address,
        City: selectedBranch.City,
        State: selectedBranch.State,
        StateId: selectedBranch.State.Id,
        CityId: selectedBranch.City.Id,
        ReporterName: `${localize.branch}: ${selectedBranch.Name}${
          selectedBranch.ContactName ? ` - ${selectedBranch.ContactName}` : ""
        }`,
        ReporterEmail: selectedBranch.Email,
        ReporterPhoneNumber: selectedBranch.PhoneNumber,
        AddressComplement: selectedBranch.AddressComplement,
        ClientBranchId: selectedBranch.Id,
      });
    }

    setShow(false);
  };

  const handleBranchChange = (currentBranch) => {
    setSelectedBranch(currentBranch);
  };

  const handleCheckedChanged = (value) => {
    setUseMainAddress(value.target.checked);
  };

  return (
    <ModalBackground
      title={localize.branch}
      showModal={show}
      setShowModal={setShow}
      okButtonText={localize.select}
      validators={!selectedBranch && !useMainAddress}
      onClickToCancel={cancel}
      onClickToSubmit={submit}
      Component={
        <Box className="flex flex-col gap-2" sx={{ width: "600px" }}>
          <Alert className="w-full" severity="info">
            {localize.select_branch_message}
          </Alert>

          <FormControlLabel
            size="small"
            name="UseMainAddress"
            control={
              <Checkbox
                size="small"
                name="UseMainAddress"
                checked={useMainAddress}
                onChange={handleCheckedChanged}
              />
            }
            label={
              <span style={{ fontSize: "0.8em" }}>
                {localize.i_want_to_use_main_address}
              </span>
            }
          />

          {!useMainAddress && (
            <Combobox
              id="ClientBranch"
              fieldLabel={localize.branches}
              fieldOptions={branches ?? []}
              fieldValue={selectedBranch}
              handleValueChange={handleBranchChange}
              popperFullWidth={PopperFullWidth}
              customOptionLabel={(option) =>
                `${option.Name} (${option.City?.Name})`
              }
            />
          )}

          {useMainAddress && (
            <Box className="two_columns_grid">
              <label className="field_title_text">
                <b>{`${localize.name}:`}</b>
              </label>
              <label className="field_title_text">{client.Name}</label>
              <label className="field_title_text">
                <b>{`${localize.address}:`}</b>
              </label>
              <label className="field_title_text">{client.Address}</label>
              <label className="field_title_text">
                <b>{`${localize.department}:`}</b>
              </label>
              <label className="field_title_text">{client.State?.Name}</label>
              <label className="field_title_text">
                <b>{`${localize.city}:`}</b>
              </label>
              <label className="field_title_text">{client.City?.Name}</label>
              <label className="field_title_text">
                <b>{`${localize.phone_number}:`}</b>
              </label>
              <label className="field_title_text">{client.PhoneNumber}</label>
              {selectedBranch?.ContactName && (
                <label className="field_title_text">
                  <b>{`${localize.contact_name}:`}</b>
                </label>
              )}
              {selectedBranch?.ContactName && (
                <label className="field_title_text">{client.ContactName}</label>
              )}
            </Box>
          )}

          {!useMainAddress && selectedBranch && (
            <Box
              className="two_columns_grid my-2 w-full"
              sx={{ overflowX: "auto" }}
            >
              <label className="field_title_text">
                <b>{`${localize.name}:`}</b>
              </label>
              <label className="field_title_text">{selectedBranch.Name}</label>
              <label className="field_title_text">
                <b>{`${localize.address}:`}</b>
              </label>
              <label className="field_title_text">
                {selectedBranch.Address}
              </label>
              <label className="field_title_text">
                <b>{`${localize.department}:`}</b>
              </label>
              <label className="field_title_text">
                {selectedBranch.State?.Name}
              </label>
              <label className="field_title_text">
                <b>{`${localize.city}:`}</b>
              </label>
              <label className="field_title_text">
                {selectedBranch.City?.Name}
              </label>
              <label className="field_title_text">
                <b>{`${localize.phone_number}:`}</b>
              </label>
              <label className="field_title_text">
                {selectedBranch.PhoneNumber}
              </label>
              {selectedBranch.Email && (
                <label className="field_title_text">
                  <b>{`${localize.email}:`}</b>
                </label>
              )}
              {selectedBranch.Email && (
                <label className="field_title_text">
                  {selectedBranch.Email}
                </label>
              )}
              {selectedBranch?.ContactName && (
                <label className="field_title_text">
                  <b>{`${localize.contact_name}:`}</b>
                </label>
              )}
              {selectedBranch?.ContactName && (
                <label className="field_title_text">
                  {selectedBranch.ContactName}
                </label>
              )}
            </Box>
          )}
        </Box>
      }
    />
  );
}
